import axios from 'axios'
import store from '../redux/createStore'

const BASE_URL =
    process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_BASE_URL : 'http://admin.dev.ekko.chat'
 //const BASE_URL = 'http://localhost:4000'

const serialize = obj => {
    var str = []
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
        }
    return str.join('&')
}

class InstanceAxios {
    static instance = null

    static init = () => {
        InstanceAxios.instance = axios.create({
            baseURL: BASE_URL,
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: false
        })
    }

    static setHeaders = () => {
        const state = store.getState()

        const token = state.admin.me.jwt
        const appId = state.ekko.currentAppId

        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        } else {
            delete axios.defaults.headers.common['Authorization']
        }

        if (appId) {
            axios.defaults.headers.common['app-id'] = appId
        } else {
            delete axios.defaults.headers.common['app-id']
        }
    }

    static get = (apiUrl, payload) => {
        InstanceAxios.setHeaders()

        return InstanceAxios.instance.get(`${apiUrl}?${serialize(payload)}`).then(response => response.data)
    }

    static post = (apiUrl, payload) => {
        InstanceAxios.setHeaders()

        return InstanceAxios.instance.post(apiUrl, payload).then(response => response.data)
    }

    static put = (apiUrl, payload) => {
        InstanceAxios.setHeaders()

        return InstanceAxios.instance.put(apiUrl, payload).then(response => response.data)
    }

    static delete = (apiUrl, payload) => {
        InstanceAxios.setHeaders()

        return InstanceAxios.instance.delete(apiUrl, payload).then(response => response.data)
    }
}

export default InstanceAxios
